import { render, staticRenderFns } from "./contentUserChangeGroup.vue?vue&type=template&id=3a25834f&"
import script from "./contentUserChangeGroup.vue?vue&type=script&lang=js&"
export * from "./contentUserChangeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports